import styled from 'styled-components';
import { Button, NavLink, NavItem, Input } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const FilterAndDown = styled.div`
	display: flex;

	justify-content: right;
	margin-bottom: 10px;
`;

export const TextClick = styled.div`
	cursor: pointer;

	margin-right: 20px;
	font-size: 18px;

	svg {
		color: ${color.secondary};
	}
`;

export const ButtonStyled = styled(Button)`
	background-color: ${({ disabled }) =>
		!disabled ? '#dbdbdb' : color.primary} !important;
	border-radius: 0 !important;
	border: 0 !important;
	color: ${({ disabled }) =>
		!disabled ? color.gray : color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.primary} !important;
		opacity: 0.6 !important;
	}
`;

export const TabsNavigation = styled.div`
	border-bottom: 2px solid ${color.primary};
	margin-bottom: 30px;
	@media (max-width: 768px) {
		border-bottom: 0;
	}
`;

export const NavLinkStyled = styled(NavLink)`
	background-color: ${(props) =>
		props.active ? color.primary : '#FFF'} !important;
	color: ${(props) => (props.active ? 'white' : '#999999')} !important;
	padding: 10px 20px !important;
	border-radius: 10px 10px 0px 0px !important;
	margin-right: 10px !important;
	font-size: 18px !important;
	margin-bottom: 0 !important;
	cursor: pointer !important;

	@media (max-width: 768px) {
		border-radius: 0 !important;
		height: 48px;
		padding: 10px 20px 10px 20px !important;
	}

	&:hover {
		background-color: #8dfdc1 !important;
		color: white !important;
	}

	&:before {
		border: 0 !important;
	}

	&:after {
		border: 0 !important;
	}
`;

export const NavItemStyled = styled(NavItem)`
	text-align: center;

	@media (max-width: 768px) {
		width: 100%;
		.nav-link {
			width: 100%;
		}
		margin: 0px 10px 0 15px !important;
	}
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		text-align: center;
		padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const DivMontante = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

export const ImgMontante = styled.img`
	filter: brightness(0);
`;

export const TextMontante = styled.div``;

export const ButtonStyle = styled(Button)`
	background-color: ${color.blue};
	border-radius: 15px;
	color: ${color.white};
	border-color: transparent;
`;

export const ButtonStyleLancamento = styled(Button)`
	background-color: ${color.yellow};
	border-radius: 15px;
	color: ${color.black};
	border-color: transparent;
`;

export const CheckBoxCss = styled(Input)`
	width: 20px;
	height: 20px;

	background-color: white !important;

`;
